// Thin API helper for Culinera. Sends cookies (for Google session) AND a
// Bearer JWT (for email/password users) on every request. 401s bubble up.

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

const jwtKey = 'culinara_jwt';

export const getStoredJwt = () => localStorage.getItem(jwtKey) || null;
export const setStoredJwt = (t) => {
  if (t) localStorage.setItem(jwtKey, t);
  else localStorage.removeItem(jwtKey);
};

export async function apiFetch(path, { method = 'GET', body, headers = {}, raw = false } = {}) {
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  const jwt = getStoredJwt();
  if (jwt && !finalHeaders.Authorization) {
    finalHeaders.Authorization = `Bearer ${jwt}`;
  }
  const res = await fetch(`${BACKEND}${path}`, {
    method,
    credentials: 'include',
    headers: finalHeaders,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (raw) return res;
  const text = await res.text();
  let data = null;
  if (text) {
    try { data = JSON.parse(text); }
    catch { data = { detail: text }; }
  }
  if (!res.ok) {
    const msg = (data && (data.detail || data.message)) || res.statusText;
    const err = new Error(Array.isArray(msg) ? msg.map((m) => m.msg).join(', ') : msg);
    err.status = res.status;
    throw err;
  }
  return data;
}
